module.exports = __webpack_public_path__ + "static/media/facebook.b3a6df3c.svg";